import { Closed as ClosedIcon, Heading } from '@pretamanger/component-library'
import Translation from '#src/common/components/translation'
import BackButton from '#src/common/app/components/navigation/back'
import { ClosedWrapper } from './styles'

const OrderAheadClosedMessage = () => {
  return (
    <ClosedWrapper data-testid='closed-wrapper'>
      <div className='mb-8 w-20'>
        <ClosedIcon colour='pretRed-700' />
      </div>
      <Heading level='h1' styleOverride='headingSm'>
        <Translation id='shop.timeslots.closed.title' />
      </Heading>
      <p className='mb-10 md:w-2/5'>
        <Translation id='shop.timeslots.closed.content' />
      </p>
      <BackButton />
    </ClosedWrapper>
  )
}

export default OrderAheadClosedMessage
